export default function() {
  var $rememberMe = $('.tml-rememberme-wrap');
  var $checkBox = $('#rememberme');

  $('.tml-user-login-wrap input, .tml-user-pass-wrap input').focus( function() {
    $(this).parent().addClass('active');
  });

  $('.tml-user-login-wrap input, .tml-user-pass-wrap input').blur( function() {
    $(this).parent().removeClass('active');
  });

  $rememberMe.click( function() {
    $(this).toggleClass('checked');
    if ( $checkBox.is(':checked') ) {
      $checkBox.prop('checked', false);
    } else {
      $checkBox.prop('checked', true);
    }
  });

  var $loginContainer = $('.login__container');
  $loginContainer.show().addClass('animated fadeIn fast').on('animationend', function() {
    $loginContainer.removeClass('animated fadeIn fast');
  });
}



// WEBPACK FOOTER //
// ./scripts/components/SetupLogin.js